import { cn } from "@/lib/utils";

export const SECURITIES_DISCLAIMER_TEXT =
  "The information on this website is solely educational and is not an offer for the sale of securities. " +
  "Only a formal, privately distributed offering memorandum and appropriate securities documents (that contain important information about investment objectives, risks, fees, and expenses) will represent any offer or subsequent sale of investment. " +
  "A person's indication of interest involves no obligation or commitment of any kind. " +
  "Any offer may be withdrawn or revoked, without obligation or commitment of any kind, at any time before notice of its acceptance is given after the qualification date. " +
  "Past performance does not guarantee or indicate future results. " +
  "Any historical returns, expected returns, or probability projections may not reflect actual future performance. " +
  "Investing involves risk, including loss of principal, and no assurance or representation is made by any person that any forecast or projection will be achieved. " +
  "Therefore, nothing contained on this website should be relied upon as a promise, forecast, guarantee, or representation regarding the future. " +
  "While the data we use from third parties is believed to be reliable, we cannot ensure the accuracy or completeness of data provided by investors or other third parties. " +
  "Neither Veras Capital nor any of its affiliates provide tax advice and do not represent in any manner that the outcomes described herein will result in any specific tax consequence. " +
  "Prospective investors should consult with their own legal and financial advisors before making any investment decisions.";

interface SecuritiesDisclaimerProps {
  className?: string;
  textClassName?: string;
  showHeading?: boolean;
  headingClassName?: string;
}

/**
 * Single source of truth for the site-wide "not an offer to sell securities"
 * disclaimer. Color is inherited from the parent so it can sit in dark footers,
 * the deal-room disclosure, or the light/dark Terms page. Wrap it with a text
 * color utility on the parent to match the surrounding fine print.
 */
export function SecuritiesDisclaimer({
  className,
  textClassName,
  showHeading = false,
  headingClassName,
}: SecuritiesDisclaimerProps) {
  return (
    <div className={className} data-testid="securities-disclaimer">
      {showHeading && (
        <p className={cn("font-semibold mb-1", headingClassName)}>
          Securities Disclaimer
        </p>
      )}
      <p className={cn("leading-relaxed", textClassName)}>
        {SECURITIES_DISCLAIMER_TEXT}
      </p>
    </div>
  );
}
